"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveIdentityProviderFromUrl = void 0;
const constant_1 = require("../constant");
const getSearchParamValueFromUrl_1 = require("./getSearchParamValueFromUrl");
const resolveIdentityProviderFromUrl = (urlStr) => resolveProvider((0, getSearchParamValueFromUrl_1.getSearchParamValueFromUrl)(urlStr, 'provider'));
exports.resolveIdentityProviderFromUrl = resolveIdentityProviderFromUrl;
const resolveProvider = (provider) => {
    if (!provider) {
        return null;
    }
    return constant_1.COGNITO_IDENTITY_PROVIDERS[capitalize(provider)] ?? provider;
};
const capitalize = (value) => `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`;
